module.exports = __webpack_public_path__ + "img/consiglio.bcbab992.jpeg";